/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - write unit tests for different use cases
*/

import { Serialize } from 'root/utils/serialize/serialize';

const SerializeForm = function () {
    const pair = function (key, value) {
        this.key = key;
        this.value = value;
    };
    pair.prototype = {
        getKey() {
            return this.key;
        },
        getValue() {
            return this.value;
        },
        isSet() {
            return typeof this.key !== 'undefined' && typeof this.value !== 'undefined';
        },
    };

    function form(formElement) {
        const data = scrapeForm(formElement);
        return Serialize(data);
    }

    function scrapeForm(formElement) {
        const obj = {};
        const formElements = formElement.querySelectorAll('input, select, textarea');
        for (let i = 0; i < formElements.length; ++i) {
            const pair = getKeyValuePairFormElement(formElements[i]);
            if (pair.isSet()) {
                obj[pair.getKey()] = pair.getValue();
            }
        }
        return obj;
    }

    function getKeyValuePairFormElement(formElement) {
        const formElementType = formElement.type;
        switch (formElementType) {
            case 'checkbox': {
                const isChecked = formElement.checked ? 1 : 0;
                return new pair(formElement.name, isChecked);
            }
            default:
                return new pair(formElement.name, formElement.value);
        }
    }

    return {
        form,
    };
};

export { SerializeForm };
